import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const IndexComponentsIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            d="M9.5 7h9M9.5 12h9M9.5 17h9"
        />
        <circle cx="6" cy="7" r="1.15" fill="currentColor" />
        <circle cx="6" cy="12" r="1.15" fill="currentColor" />
        <circle cx="6" cy="17" r="1.15" fill="currentColor" />
    </SvgIcon>
)

export default IndexComponentsIcon
